import React from 'react';
import { APP_INFO } from '../../utils/settingsConstants';

/**
 * About tab component
 * Displays application version, features, and support information
 */
const AboutTab = () => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Pest Control CRM</h3>
        <div className="space-y-4">
          <div className="p-4 border border-gray-200 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">Version Information</h4>
            <div className="text-sm text-gray-600 space-y-1">
              <p>Version: {APP_INFO.version}</p>
              <p>Built with: {APP_INFO.technologies}</p>
              <p>Last Updated: {new Date().toLocaleDateString()}</p>
            </div>
          </div>

          <div className="p-4 border border-gray-200 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2">Support</h4>
            <p className="text-sm text-gray-600 mb-2">
              For technical support or feature requests, please contact:
            </p>
            <p className="text-sm text-pest-blue">{APP_INFO.supportEmail}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTab;